import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../components/helper";

export const getAllergens = createAsyncThunk(
  "allergen/getAllergens",
  async () => {
    const response = await http.get("allergenlist");
    return response.data.data;
  }
);

const initialState = {
  allergenList: [],
  status: "idle",
  error: null,
};

const allergenSlice = createSlice({
  name: "Allergen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllergens.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllergens.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allergenList = action.payload;
      })
      .addCase(getAllergens.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default allergenSlice.reducer;
